import Environment from '../constants/Environment';
import GraphEndpoint from '../constants/GraphEndpoint';
import getEnvironment from './getEnvironment';

const ENDPOINT_BY_ENVIRONMENT = {
  [Environment.DEVELOPMENT]: GraphEndpoint.LOCALHOST,
  [Environment.STAGING]: GraphEndpoint.STAGING,
  [Environment.RAINFORESTQA]: GraphEndpoint.RAINFORESTQA,
  [Environment.SANDBOX]: GraphEndpoint.SANDBOX,
  [Environment.PRODUCTION]: GraphEndpoint.PRODUCTION,
};

const getGraphEndpoint = (environment?: Environment): string => {
  return `${ENDPOINT_BY_ENVIRONMENT[environment || getEnvironment(window)]}/graphql`;
};

export default getGraphEndpoint;
